import validate from "/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/src/middleware/auth.global.js";
import booking_45global from "/src/middleware/booking.global.js";
import guard_45global from "/src/middleware/guard.global.js";
import redirects_45global from "/src/middleware/redirects.global.js";
import manifest_45route_45rule from "/src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  booking_45global,
  guard_45global,
  redirects_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "sidebase-auth": () => import("/src/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}